module.exports = __webpack_public_path__ + "static/media/anzuum (3).4eb75df8.png";